import type { CustomContentDTO, CustomContentAssignmentDTO } from '@hmedia/legenda-ds-api-client'

/**
 * View Type enum matching backend
 */
export enum ViewType {
  GATE_INFO_HEADER = 'GATE_INFO_HEADER',
  GENERAL_INFO_HEADER = 'GENERAL_INFO_HEADER',
  FULLSCREEN_IMAGE = 'FULLSCREEN_IMAGE',
}

/**
 * View Type display labels
 */
export const ViewTypeLabels: Record<ViewType, string> = {
  [ViewType.GATE_INFO_HEADER]: 'GATE típusú járatinformációs fejléccel',
  [ViewType.GENERAL_INFO_HEADER]: 'Általános járatinformációs fejléccel',
  [ViewType.FULLSCREEN_IMAGE]: 'Csak a képet mutassa teljes kijelzőn',
}

/**
 * Custom Content DTO for admin interface
 */
export interface CustomContentAdminDTO extends CustomContentDTO {
  key: string
}

/**
 * Custom Content Assignment DTO for admin interface
 */
export interface CustomContentAssignmentAdminDTO extends CustomContentAssignmentDTO {
  key: string
}

/**
 * Form values for creating/updating custom content
 */
export interface CustomContentFormValues {
  name: string
  viewType: ViewType
  imageFile?: File
  croppedImage?: Blob
}

/**
 * Cropped area from react-easy-crop
 */
export interface CroppedArea {
  x: number
  y: number
  width: number
  height: number
}

/**
 * Gate options for screen assignment
 */
export const GateOptions = {
  GATE1: { value: 'GATE1', label: 'Gate 1' },
  GATE2: { value: 'GATE2', label: 'Gate 2' },
  GATE3: { value: 'GATE3', label: 'Gate 3' },
  NONE: { value: null, label: 'Egyéb' },
} as const

export type GateOptionValue = keyof typeof GateOptions